<mat-card *ngIf="profile" class="player-header-card">
  <mat-card-content class="header-content">

    <div class="player-avatar">
      <mat-icon class="avatar-icon">account_circle</mat-icon>
    </div>

    <div class="player-info">
      <h1 class="player-name">{{ profile.full_name }}</h1>

      <div class="player-details">
        <div class="detail-item" *ngIf="profile.date_of_birth">
          <mat-icon>cake</mat-icon>
          <span>{{ profile.date_of_birth | date: 'longDate' }}</span>
        </div>

      </div>
    </div>

  </mat-card-content>
</mat-card>
